import React, { forwardRef } from "react";

const EndorsementLetter = forwardRef(({ data }, ref) => {
  if (!data) return null;
  const t = data.template;

  return (
    <div ref={ref} className="printable" style={{ fontFamily: '"Times New Roman", serif', fontSize: "12pt", lineHeight: 1.5, color: "black" }}>

      {/* ── Row 1: Letterhead banner (if set) ── */}
      {t.letterheadUrl && (
        <div style={{ marginBottom: 8 }}>
          <img src={t.letterheadUrl} alt="Letterhead" style={{ width: "100%", display: "block" }} />
        </div>
      )}

      {/* ── Row 2: Logo + Agency name/address (left) | Date (right) ── */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 48, marginTop: 48 }}>
        <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
          {t.logoUrl && (
            <img src={t.logoUrl} alt="Logo" style={{ height: 50, width: "auto", objectFit: "contain", flexShrink: 0 }} />
          )}
          <div>
            <div style={{ fontWeight: "bold", fontSize: "12pt" }}>GOLDEN GATEWAY INTERNATIONAL AGENCY</div>
            <div style={{ fontSize: "11pt" }}>Don Gil Garcia Street, Capitol Site, Cebu City</div>
          </div>
        </div>
        <div style={{ fontSize: "11pt", whiteSpace: "nowrap" }}>
          Date: {data.issueDateFormatted}
        </div>
      </div>

      {/* ── Title ── */}
      <h2 style={{ fontFamily: '"Times New Roman", serif', textAlign: "center", textDecoration: "underline", fontSize: "14pt", margin: "0 0 20px" }}>
        ENDORSEMENT LETTER
      </h2>

      <p style={{ marginBottom: 12 }}>Dear Sir/Madam,</p>
      <p style={{ marginBottom: 16 }}>Warm greetings!</p>

      <p style={{ textAlign: "justify", marginBottom: 14 }}>
        This is to formally endorse <strong>{data.titledName}</strong>, a {t.employerStatus} employee of <strong>{t.company}</strong>, for possible employment under your esteemed agency as a <strong>{t.endorseAs}</strong>.
      </p>

      <p style={{ textAlign: "justify", marginBottom: 14 }}>
        {data.titledLast} has been employed with our company from <strong>{data.startDateFormatted} to Present</strong> as a <strong>{t.role}</strong>. During {data.pronoun.poss} employment, {data.pronoun.subj.toLowerCase()} has been actively involved in {t.duties}. {data.pronoun.subj} has consistently demonstrated diligence, dependability, and a strong sense of responsibility in all assigned duties.
      </p>

      <p style={{ textAlign: "justify", marginBottom: 14 }}>
        We are confident that {data.pronoun.poss} skills, work ethic, and experience in {t.expertise} make {data.pronoun.obj} highly suitable for overseas employment in the {t.industry}. We strongly recommend {data.pronoun.obj} for any position related to {data.pronoun.poss} field of expertise.
      </p>

      <p style={{ marginBottom: 14 }}>Should you require further information, please feel free to contact us at your convenience.</p>
      <p style={{ marginBottom: 30 }}>Thank you for your kind attention and consideration.</p>

      <p style={{ marginBottom: 50 }}>Respectfully yours,</p>

      {/* ── Signature block — centered ── */}
      <div style={{ textAlign: "center" }}>
        {t.signatureUrl && (
          <img src={t.signatureUrl} alt="Signature" style={{ height: 48, width: "auto", display: "block", margin: "0 auto 4px" }} />
        )}
        <div style={{ fontWeight: "bold" }}>{t.manager}</div>
        <div>Manager</div>
      </div>
    </div>
  );
});

export default EndorsementLetter;
